// extracted by mini-css-extract-plugin
export default {"productcard":"TM","productimage":"UM","username":"VM","multiBagName":"WM","productinfo":"XM","productinfoinner":"YM","productname":"ZM","productsubheader":"aN","productdescription":"bN","productnumbers":"cN","productnumberstitle":"eN","productnumbersitem":"fN","number":"gN","numbertext":"hN","tabs":"iN","benefitsblock":"jN","benefit":"kN","benefitname":"lN","benefitdescription":"mN","ingredientsblock":"nN","tipsblock":"oN","mobileonly":"pN"};
    if(module.hot) {
      // 1721922364849
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  